import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const TEXT = {
  es: { message: 'Hay una nueva versi\u00f3n de Flash Multiservice.', reload: 'Actualizar' },
  en: { message: 'A new version of Flash Multiservice is available.', reload: 'Update' },
  fr: { message: 'Une nouvelle version de Flash Multiservice est disponible.', reload: 'Mettre \u00e0 jour' },
};

const CHECK_EVERY_MS = 5 * 60 * 1000;
const getText = (lang) => TEXT[(lang || 'es').slice(0, 2)] || TEXT.es;

const currentBundle = () => {
  const script = document.querySelector('script[src*="/static/js/main."]');
  return script ? script.getAttribute('src') : null;
};

function UpdateBanner() {
  const { i18n } = useTranslation();
  const tx = getText(i18n.language);
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    const mine = currentBundle();
    if (!mine) return undefined;
    let stopped = false;
    const check = async () => {
      if (stopped || document.visibilityState !== 'visible') return;
      try {
        const response = await fetch(`/index.html?check=${Date.now()}`, { cache: 'no-store' });
        if (!response.ok) return;
        const html = await response.text();
        const match = html.match(/\/static\/js\/main\.[a-z0-9]+\.js/);
        if (match && match[0] !== mine) setAvailable(true);
      } catch (err) {
        // Sin conexion: se vuelve a intentar en la siguiente comprobacion.
      }
    };
    const onVisible = () => {
      if (document.visibilityState === 'visible') check();
    };
    const timer = setInterval(check, CHECK_EVERY_MS);
    document.addEventListener('visibilitychange', onVisible);
    check();
    return () => {
      stopped = true;
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);

  if (!available) return null;
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] bg-surface border border-accent rounded-xl px-4 py-3 flex items-center gap-3 shadow-lg max-w-[92vw]">
      <span className="text-white text-sm">{tx.message}</span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="bg-accent text-panel font-bold text-sm px-4 py-1.5 rounded-lg cursor-pointer shrink-0"
      >
        {tx.reload}
      </button>
    </div>
  );
}

export default UpdateBanner;